import React from 'react';

const Meal = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M16.503 21.411c0 .483.376.874.84.874h.674c.464 0 .84-.391.84-.874V2.151a.424.424 0 0 0-.398-.437c-1.723-.023-3.709 2.637-3.709 7.87a4.38 4.38 0 0 0 1.47 3.55.87.87 0 0 1 .283.655zm-7.91.874c.486.001.88-.39.88-.873v-7.45c0-.948.393-1.376.816-1.838.492-.538 1.025-1.12 1.025-2.623 0-2.308-.345-6.608-.424-7.589a.217.217 0 0 0-.22-.198h-.463a.22.22 0 0 0-.22.214l-.15 5.495a.453.453 0 0 1-.436.439.454.454 0 0 1-.473-.433l-.25-5.505a.22.22 0 0 0-.22-.21H8a.22.22 0 0 0-.22.21s-.241 5.264-.25 5.505a.453.453 0 0 1-.443.433.453.453 0 0 1-.467-.44l-.15-5.494a.22.22 0 0 0-.22-.214h-.463a.217.217 0 0 0-.22.198c-.08.98-.424 5.28-.424 7.589 0 1.502.533 2.086 1.026 2.624.422.462.814.89.814 1.837v7.45c0 .483.395.874.882.874z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Meal;
